import propTypes from 'prop-types';
import React from 'react';

const Tabs = ({tabState, changeTab, tabs}) => {

    return (
        <section className='mt-3' data-test='component-tabs'>
            <ul className="nav nav-tabs">

                {tabs.map(tab => (
                    <li className='nav-item' key={Math.random().toString(33).replace('0.', '')}>
                        <div className={tabState === tab ? 'nav-link text-primary active text-capitalize' : 'nav-link text-capitalize'}
                             style={{cursor: 'pointer'}}
                             onClick={() => changeTab(tab)}>
                            {tab}
                        </div>
                    </li>
                ))}

            </ul>
        </section>
    );
}

export default Tabs;

Tabs.propTypes = {
    tabState: propTypes.string.isRequired,
    tipoCorso: propTypes.string.isRequired,
    changeTab: propTypes.func.isRequired
};
